import { onMounted, onUnmounted } from "vue"

export default function onKeyDown(handler: (event: KeyboardEvent) => void) {
  onMounted(() => {
    window.addEventListener("keydown", handler)
  })

  onUnmounted(() => {
    window.removeEventListener("keydown", handler)
  })
}
